import { render, staticRenderFns } from "./CurrentReservationWidget.vue?vue&type=template&id=0f509c78"
import script from "./CurrentReservationWidget.vue?vue&type=script&lang=js"
export * from "./CurrentReservationWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports